module.exports = __webpack_public_path__ + "img/egypt_s_book_of_mystery.145ee23e.jpg";